import React from 'react';
import { motion } from 'framer-motion';
import { HelpCircle, XCircle } from 'lucide-react';
const objections = [{
  q: '"No tengo experiencia en diseño"',
  a: "Exacto. Por eso funciona. El protocolo está diseñado para que la IA haga el trabajo pesado. Tú solo copias los prompts. Si sabes escribir en WhatsApp, sabes usar esto."
}, {
  q: '"Es demasiado barato, seguro es basura"',
  a: "El precio de lanzamiento es una estrategia de validación. Lo estamos usando para conseguir casos de éxito rápido. Cuando lleguemos al límite, sube a $47. Estás aprovechando una ventana, no un descuento eterno."
}, {
  q: '"¿Es solo información que encuentro gratis en YouTube?"',
  a: "En YouTube encuentras piezas sueltas y desordenadas que te toman meses armar. Aquí tienes el sistema completo, en orden, con los prompts exactos y una comunidad que te corrige en tiempo real. El valor no está en la información. Está en el atajo."
}, {
  q: '"No tengo tiempo ahora"',
  a: 'El protocolo entero está diseñado para producir tu primer anuncio en 15 minutos. La pregunta no es si tienes tiempo. Es cuánto dinero más vas a perder mientras "no tienes tiempo".'
}];
export function Objections() {
  return <section className="py-12 md:py-24 bg-zinc-950 px-4" data-id="element-94" data-mp="3mps05czkr8la">
      <div className="max-w-4xl mx-auto" data-id="element-95" data-mp="3rms6lp0c6dcx">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10 md:mb-16" data-id="element-96" data-mp="3rntgvr9j2vtl">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-red-500/10 text-red-400 text-sm font-medium mb-6" data-id="element-97" data-mp="o630u58kv7ob">
            <XCircle className="w-4 h-4" data-id="element-98" data-mp="e8f0mzs7d7yr" />
            ANTES DE QUE ENCUENTRES UNA EXCUSA
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-99" data-mp="2tzt6136iwl9r">
            Las 4 Razones Por Las Que Te Estás Convenciendo de No Comprar (Y Por Qué Están Equivocadas)
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-4 md:gap-6" data-id="element-100" data-mp="15gf68lv5ov5s">
          {objections.map((obj, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="p-6 rounded-2xl bg-zinc-900 border border-zinc-800" data-id="element-101" data-mp="10gkhanuxyfnd" data-mpi={i}>
              <div className="flex gap-3 mb-4" data-id="element-102" data-mp="lspnt5940798">
                <HelpCircle className="w-6 h-6 text-amber-500 shrink-0" data-id="element-103" data-mp="hqciuj26sddi" />
                <h3 className="text-white font-bold text-lg" data-id="element-104" data-mp="hp1gmnoe3doi">{obj.q}</h3>
              </div>
              <p className="text-zinc-400 pl-9" data-id="element-105" data-mp="crrqt6x39005">{obj.a}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}